// DialogTeamSelect Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../layout/dialog/dialog.jsx'
import TeamItem from '../../team/team_item/team_item.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class DialogTeamSelect extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: true
    }
  }

  static get propTypes () {
    return {
      teams: PropTypes.array.isRequired,
      onSelect: PropTypes.func,
      onClose: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      teams: [],
      onSelect: null,
      onClose: null
    }
  }

  render () {
    return (
      <Dialog
        active={this.state.active}
        onClose={this.props.onClose}
        type='large'
        animationType='fast'
      >
        <div className='dialog-team-select'>
          <div className='contentleft'>{this._renderInfo()}</div>
          <div className='contentright'>{this._renderTeamList()}</div>
        </div>
      </Dialog>
    )
  }

  /* Event handlers */
  _onSelectTeam (team) {
    if (this.props.onSelect !== undefined) {
      this.props.onSelect(team.id)
    }
  }

  /* Private Functions */
  _renderTeamList () {
    if (!this.props.teams) {
      return ''
    }

    return this.props.teams.map((team, idx) => (
      <TeamItem
        key={idx}
        team={team}
        onSelect={this._onSelectTeam.bind(this, team)}
      />
    ))
  }

  _renderInfo () {
    return (
      <div className='typo info'>
        <h2>
          <IntlMessage ident='common.team.contentTitle' />
        </h2>
        <div className='content'>
          <p>
            <IntlMessage ident='common.team.contentInfo' />
          </p>
        </div>
      </div>
    )
  }
}

export default DialogTeamSelect
